module.exports = __webpack_public_path__ + "img/eb3b170.png";